import { ADD_RETURN_PO, DELETE_RETURN_PO, EDIT_RETURN_PO, LIST_OF_RETURN_PO, PO_RETURN_HISTORY, UPDATE_PO_RETURN_STATUS, VIEW_PO_RETURN, VIEW_SINGLE_PO_RETURN } from "./ApiRoutes";
import { authData } from "./services";


export const listOfReturnPO = async (data: object) => {
    const response = await authData.post(LIST_OF_RETURN_PO, data);
    return response?.data;
  };

  export const deletePOReturn = async (id: number) => {
    const response = await authData.delete(`${DELETE_RETURN_PO}${id}`);
    return response?.data;
  };

  export const addPOReturn = async (data: object) => {
    const response = await authData.post(ADD_RETURN_PO,data);
    return response?.data;
  };

  export const editPOReturn = async (id: number,data: object) => {
    const response = await authData.put(`${EDIT_RETURN_PO}/${id}`,data);
    return response?.data;
  };


  export const historyOfPoReturn = async (id: number, data: object) => {
    const response = await authData.post(`${PO_RETURN_HISTORY}/${id}`, data);
    return response?.data;
  };

  export const updatePOReturnStatus = async (id: number) => {
    const response = await authData.put(`${UPDATE_PO_RETURN_STATUS}${id}`);
    return response?.data;
  };

  export const viewPoReturn = async (id: number) => {
    const response = await authData.post(`${VIEW_PO_RETURN}/${id}`);
    return response?.data;
  };

  export const viewSinglePoReturn = async (id: number) => {
    const response = await authData.post(`${VIEW_SINGLE_PO_RETURN}/${id}`);
    return response?.data;
  };
